import React from 'react'
import SplitPane from 'react-split-pane'
import MessageUtils from '../../util/MessageUtils'
import EmptyListUI from '../../widgets/output/EmptyListUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import TaskListUI from '../../components/projectapp/taskList/TaskListUI'
import TaskDetailSF from '../../components/projectapp/taskDetail/TaskDetailSF'
import TaskDeleteModalUI from '../../components/projectapp/taskList/TaskDeleteModalUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import prjLogoLite from '../../assets/projectapp/lite_top/color_logo_transparent.png'
import prjLogoDark from '../../assets/projectapp/dark_top/color_logo_transparent.png'
import './TaskListPage.css'
import './TaskListSplitPane.css'

const TaskListPageUI = ({context, messageList, taskList, project, currentTask, onSetEditMode,
    projectUserList, projectUserMap,
    // filters
    statusFilter, priorityFilter, onStatusFilterChange, onPriorityFilterChange,
    dueDateDaysFilter, onDueDateDaysFilterChange,
    searchFilter, onSearchFilterChange, assigneeFilter, onAssigneeFilterClick,
    unfoldedTaskIdSet,
    // list of values
    statusList, priorityList,
    // top action clicks
    onRefreshClick, onUnfoldAllClick, onFoldAllClick, onCreateClick,
    onDeleteClick, onIndentClick, onOutdentClick, onMoveClick, pageRendered, moveMode,
    // row level clicks
    onUnfoldClick, onFoldClick, onTaskClick,
    onTaskNameCreateOrUpdate,
    // dnd
    onBeforeCapture, onDragEnd,
    // delete modal
    deleteModal, deleteSubmitted, onDeleteSubmit, onCancelDelete, deleteSuccessMsg, deleteErrorList, setDeleteErrorList,
    // task detail handler
    onTaskListUpdated, onForceTaskListRefresh, onForceProjectUserListRefresh
  }) =>
  <PrivatePageSF context={context} className='pg_tasks' backLink='/projects' dimension='w1600'
    messageList={messageList}
    centered={(!taskList && !pageRendered) || !projectUserList || (taskList && taskList.length === 0)}
    headerText={project ?
      `${MessageUtils.getMessageValue(messageList, project.projectType === 'project' ? 'c_project' : 'c_template')}: ${project.projectName}`
      : ''}
  >
    {
      // after page has been rendered, refresh will only show spinner inside task list area
      ((!taskList && !pageRendered) || !projectUserList || !statusList || !priorityList) &&
      <SpinnerComponentUI />
    }
    {
      taskList && taskList.length === 0 && projectUserList && statusList && priorityList &&
      <EmptyListUI
        context={context}
        messageList={messageList}
        createEnabled={project.permissionList.includes('prj_participate')}
        onCreateClick={onCreateClick}
        createLinkKey='c_add_task'
        createDisabledMessageKey='c_no_task_msg'
      />
    }

    {
      ((taskList && taskList.length > 0) || (!taskList && pageRendered)) && projectUserList && statusList && priorityList &&
      <React.Fragment>
        {/* g_h_100 is needed for internal scrolling, flex didn't work here */}
        <div className='desktop g_h_100'>
          <SplitPane split="vertical" minSize={300} defaultSize='50%'>
            <TaskListUI
              context={context}
              messageList={messageList}
              project={project}
              taskList={taskList}
              currentTask={currentTask}
              projectUserList={projectUserList}
              projectUserMap={projectUserMap}
              // top actions
              onRefreshClick={onRefreshClick}
              onUnfoldAllClick={onUnfoldAllClick}
              onFoldAllClick={onFoldAllClick}
              onCreateClick={onCreateClick}
              onDeleteClick={onDeleteClick}
              onIndentClick={onIndentClick}
              onOutdentClick={onOutdentClick}
              onMoveClick={onMoveClick}
              moveMode={moveMode}
              // filters
              statusList={statusList}
              priorityList={priorityList}
              statusFilter={statusFilter}
              searchFilter={searchFilter}
              priorityFilter={priorityFilter}
              assigneeFilter={assigneeFilter}
              dueDateDaysFilter={dueDateDaysFilter}
              onStatusFilterChange={onStatusFilterChange}
              onSearchFilterChange={onSearchFilterChange}
              onAssigneeFilterClick={onAssigneeFilterClick}
              onPriorityFilterChange={onPriorityFilterChange}
              onDueDateDaysFilterChange={onDueDateDaysFilterChange}
              unfoldedTaskIdSet={unfoldedTaskIdSet}
              // row level
              onTaskClick={onTaskClick}
              onUnfoldClick={onUnfoldClick}
              onFoldClick={onFoldClick}
              onSetEditMode={onSetEditMode}
              onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
              // dnd
              onBeforeCapture={onBeforeCapture}
              onDragEnd={onDragEnd}
            />
            {
              currentTask && currentTask.taskId !== 'create' &&
              <TaskDetailSF
                context={context}
                messageList={messageList}
                project={project}
                task={currentTask}
                // list of values
                projectUserMap={projectUserMap}
                projectUserList={projectUserList}
                // task detail event
                onTaskListUpdated={onTaskListUpdated}
                onForceTaskListRefresh={onForceTaskListRefresh}
                onForceProjectUserListRefresh={onForceProjectUserListRefresh}
              />
            }
            {
              (!currentTask || currentTask.taskId === 'create') &&
              <div className='g_flex_v g_text_center unselected'>
                <img src={context.theme === 'lite' ? prjLogoLite : prjLogoDark} alt="" />
              </div>
            }
          </SplitPane>
        </div>

        <div className='mobile g_h_100'>
          <TaskListUI
            context={context}
            messageList={messageList}
            taskList={taskList}
            project={project}
            currentTask={currentTask}
            projectUserList={projectUserList}
            projectUserMap={projectUserMap}
            pageRendered={pageRendered}
            // top actions
            onRefreshClick={onRefreshClick}
            onUnfoldAllClick={onUnfoldAllClick}
            onFoldAllClick={onFoldAllClick}
            onCreateClick={onCreateClick}
            onDeleteClick={onDeleteClick}
            onIndentClick={onIndentClick}
            onOutdentClick={onOutdentClick}
            onMoveClick={onMoveClick}
            moveMode={moveMode}
            // filters
            statusList={statusList}
            priorityList={priorityList}
            statusFilter={statusFilter}
            searchFilter={searchFilter}
            priorityFilter={priorityFilter}
            assigneeFilter={assigneeFilter}
            dueDateDaysFilter={dueDateDaysFilter}
            onStatusFilterChange={onStatusFilterChange}
            onSearchFilterChange={onSearchFilterChange}
            onAssigneeFilterClick={onAssigneeFilterClick}
            onPriorityFilterChange={onPriorityFilterChange}
            onDueDateDaysFilterChange={onDueDateDaysFilterChange}
            unfoldedTaskIdSet={unfoldedTaskIdSet}
            // row level
            onTaskClick={onTaskClick}
            onUnfoldClick={onUnfoldClick}
            onFoldClick={onFoldClick}
            onSetEditMode={onSetEditMode}
            onTaskNameCreateOrUpdate={onTaskNameCreateOrUpdate}
            // dnd
            onBeforeCapture={onBeforeCapture}
            onDragEnd={onDragEnd}
          />
        </div>

        <TaskDeleteModalUI
          context={context}
          messageList={messageList}
          errorList={deleteErrorList}
          successMsg={deleteSuccessMsg}
          setErrorList={setDeleteErrorList}
          currentTask={currentTask}
          onCancel={onCancelDelete}
          onSubmit={onDeleteSubmit}
          submitted={deleteSubmitted}
          deleteModal={deleteModal}
        />
      </React.Fragment>
    }
  </PrivatePageSF>

export default TaskListPageUI
